import React from 'react';
import PageHeader from '../components/layout/PageHeader';

export default function ReportsPage() {
  return (
    <div>
      <PageHeader
        title="Relatórios"
        subtitle="Análises e relatórios do sistema"
      />
      <p className="text-gray-500">Página em construção</p>
    </div>
  );
}